import Loadable from 'react-loadable';

import { CustomLoadableLoading } from '../../components/loading/loading.js';

const WhatIsOpenInnovationPageAsync = Loadable({
	loader: () => import(/* webpackChunkName: "what-is-open-innovation-page" */'./what-is-open-innovation.page.js'),
	modules: ['./what-is-open-innovation.page.js'],
	webpack: () => [require.resolveWeak('./what-is-open-innovation.page.js')],
	loading: CustomLoadableLoading,
});

export default WhatIsOpenInnovationPageAsync;
